import { FC, KeyboardEvent, ClipboardEvent } from 'react';
import { TextField } from '@mui/material';

interface OtpInputBaseProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  numInputs?: number;
}

const OtpInputBase: FC<OtpInputBaseProps> = ({ value, onChange, error, placeholder = 'Enter your verification code', numInputs = 6 }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value.replace(/[^0-9]/g, '').slice(0, numInputs);
    onChange(input);
  };

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const cleanedData = pastedData.replace(/[^0-9]/g, '').slice(0, numInputs);
    onChange(cleanedData);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'v') {
      return;
    }

    if (
      !/^\d$/.test(e.key) && 
      e.key !== 'Backspace' &&
      e.key !== 'Delete' &&
      e.key !== 'ArrowLeft' &&
      e.key !== 'ArrowRight' &&
      e.key !== 'Tab'
    ) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      fullWidth
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      error={!!error}
      helperText={error}
      placeholder={placeholder}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'white',
          borderRadius: '12px',
          height: '56px',
          '& fieldset': {
            borderColor: '#E5E7EB',
          },
          '&:hover fieldset': {
            borderColor: '#D1D5DB',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#3B82F6',
          },
          '&.Mui-error fieldset': {
            borderColor: '#EF4444',
          }
        },
        '& .MuiFormHelperText-root': {
          marginLeft: 0,
          marginRight: 0,
        }
      }}
    />
  );
};

export default OtpInputBase;
